<template>
  <v-card-title>
    <v-container class="pa-12">
      <v-card class="pl-16 pr-16 pt-8 pb-16">
        <div fill-width class="pb-5" align="end">
          <v-btn class="mx-2" fab dark color="#689ADE" to="/clearadvance-list">
            <v-icon color="black"> mdi-close </v-icon>
          </v-btn>
        </div>
        <v-card-title>
          <v-row>
            <v-col cols="6" md="6" justify="center">
              <h3>Clear Advance</h3>
            </v-col>
            <v-col cols="6" md="6">
              <v-row>
                <v-col class="text-right" cols="12" md="12">
                  <h5>No. {{ advance_h.advance_id }}</h5>
                  <h5>Date. {{ advance_date_show }}</h5>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>

        <v-simple-table>
          <!-- table top section -->
          <template v-slot:top>
            <v-row class="row1 heightsize70formadvance">
              <v-col cols="12" md="6">
                <v-text-field v-model="setusername" outlined disabled dense label="Employee Name"
                  background-color="#F5F5F5"></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="department" outlined disabled dense label="Department"
                  background-color="#F5F5F5"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="row1 heightsize70formadvance">
              <v-col cols="12" md="6">
                <v-autocomplete v-model="emp_draw" :items="emp_list" item-text="name" item-value="id" label="ผู้เบิก"
                  outlined dense disabled background-color="#F5F5F5"></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="4" md="6">
                <v-autocomplete v-model="emp_draw_jobtitle" :items="jobtitle_list" item-text="name" item-value="id"
                  label="Assignment / Case" outlined dense disabled background-color="#F5F5F5"></v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
              <v-col cols="12" md="6">
                <v-autocomplete v-model="customer_name" :items="customer_list" outlined disabled dense
                  label="For Client" @change="onSelectCustomerChange(customer_name)"></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="4" md="4">
                <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedExpectedClearDateFormatted" label="Expected Clear Date"
                      append-icon="mdi-calendar" readonly disabled dense outlined v-bind="attrs"
                      v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <br />
          </template>
        </v-simple-table>

        <template>
          <v-data-table :headers="headers" :items="desserts" sort-by="calories" class="elevation-1" hide-default-footer>
            <!-- <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th v-for="h in headers" :class="h.class">
                    <span>{{ h.text }}</span>
                  </th>
                </tr>
              </thead>
            </template> -->

            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Clear Advance Details</v-toolbar-title>
                <!-- <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer> -->
                <v-dialog v-model="dialog" max-width="500px">
                  <!-- <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        New Item
                      </v-btn>
                    </template> -->
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="editedItem.name" label="Dessert name"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="editedItem.calories" label="Calories"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="editedItem.fat" label="Fat (g)"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="editedItem.carbs" label="Carbs (g)"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="editedItem.protein" label="Protein (g)"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">
                        Cancel
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="save">
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="removeimage">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.clear_amount`]="{ item, index }">
              <v-text-field v-if="index == 0" autofocus @focus="$event.target.select()" type="number"
                v-model="item.clear_amount" @keyup="Caltotleamount(item)"></v-text-field>
              <v-text-field v-else @focus="$event.target.select()" type="number" v-model="item.clear_amount"
                @keyup="Caltotleamount(item)"></v-text-field>
            </template>
            <template v-slot:[`item.difference_amount`]="{ item }">
              <p v-if="item.difference_amount < 0">
                <span class="red--text">({{ item.difference_amount }})</span>
              </p>
              <p v-else-if="item.difference_amount > 0">
                <span class="green--text"> ({{ item.difference_amount }})</span>
              </p>
              <p v-else>
                <span> ({{ item.difference_amount }})</span>
              </p>
            </template>
            <template v-slot:item.description="{ item }">
              <span @click="openPreviewMaps(item.description)" class="description-text">
                {{ item.description }}
              </span>
            </template>
          </v-data-table>
        </template>

        <br />
        <v-row class="heightsize55formadvance">
          <v-col class="text-right" cols="12" md="4"> </v-col>
          <v-col class="text-right" cols="12" md="4">Balance </v-col>
          <v-col class="text-right" cols="12" md="4">
            <v-row>
              <v-col cols="12" md="12">
                <v-row>
                  <v-col class="text-right" cols="12" md="12">
                    <!--:suffix="sumwithdrawamount" -->
                    <v-text-field reverse filled disabled outlined dense v-model="sumwithdrawamount"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row align="start" justify="start">
          <v-col cols="12" md="6">
            <v-radio-group v-model="radioGroup" @change="changeradio()">
              <v-radio key="bank" label="Transfer" value="bank"></v-radio>
              <v-col v-show="pickbank">
                <v-autocomplete v-model="selectbankname" :items="bankname" label="Select Bank" outlined dense
                  ref="Select Bank"></v-autocomplete>
                <v-text-field outlined dense v-model="bankNumber" label="Account Number"></v-text-field></v-col>

              <v-radio key="cash" label="Cash" value="cash"></v-radio>

              <v-radio key="cheque" label="Cheque" value="cheque"></v-radio>
              <v-col v-show="pickcheque">
                <v-text-field outlined dense label="Cheque No" v-model="chequeNumber" ref="Cheque No"></v-text-field>
              </v-col>
            </v-radio-group>
          </v-col>
        </v-row>

        <template>
          <!-- <h5>
            <v-icon color="gray"> mdi-file-image </v-icon>Image for clear
            advance
            <span class="red--text">(Choose file for change all file)</span>
          </h5> -->
          <v-row class="mt-1">
            <v-col>
              <input type="file" accept="image/*" multiple @change="previewMultiImage" class="inputsize" ref="file"
                style="display: none" />
              <v-btn class="btnuploadfile" @click="$refs.file.click()" elevation="7">
                <v-icon left dark> mdi-cloud-upload </v-icon>Upload file
              </v-btn>

              <span class="red--text"> (only file image)</span>

              <!-- <span class="font-weight-regular subtitle-1">
                ... {{ preview_list.length }} file</span
              > -->
            </v-col>
          </v-row>

          <div class="border p-2 mt-3">
            <div v-if="this.filenameattach.length > 0">
              <span v-for="(item, index) in this.filenameattach" :key="index">
                <a @click="previewattachfile(index)">{{ item }}</a>

                <v-btn :style="{
                  backgroundColor: '#FFEBEE',
                  color: '#F44336',
                }" small icon @click="confirmdeleteattachfile(index)">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>

                <br />
              </span>
            </div>
            <!-- <template v-if="preview_list.length">
              <p>
                Preview Currently Image:
                <span class="red--text">(click image to remove image)</span>
              </p>
              <v-row>
                <v-col
                  v-for="(item, index) in preview_list"
                  :key="index"
                  class="d-flex child-flex"
                  cols="3"
                >
                  <v-img
                    :src="item"
                    class="grey lighten-2 mt-3 mb-5"
                    aspect-ratio="1"
                    contain
                    @click="deleteItemConfirm(index)"
                  >
                  </v-img>
                </v-col>
              </v-row>
            </template> -->
          </div>

          <div class="border p-2 mt-3">
            <template v-if="oldpreview_list.length">
              <p>
                Preview Old Image:
                <span class="red--text">(Preview Only)</span>
              </p>
              <v-row>
                <v-col v-for="(item, index) in oldpreview_list" :key="index" class="d-flex child-flex" cols="3">
                  <v-img disabled :src="item" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
                  </v-img>
                  <!-- <p class="mb-0">file name: {{ image_list[index].name }}</p>
                  <p>size: {{ image_list[index].size / 1024 }}KB</p> -->
                </v-col>
              </v-row>
            </template>
          </div>
        </template>
        <v-divider></v-divider>
        <br />
        <v-row>
          <v-col>
            <v-text-field v-model="remark" disabled fill-width outlined dense label="Remark"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="approver_remark" disabled fill-width outlined dense
              label="Approver Remark"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="accountant_remark" disabled fill-width outlined dense
              label="Accountant Remark"></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-3">
          <v-col align="center" cols="12" md="4">
            <v-row v-if="dialogSignature" :style="{ visibility: showsig1 ? 'visible' : 'hidden' }">
              <VueSignaturePad class="signature" width="90%" height="200" ref="firstsignaturePad" :options="options" />
              <v-row :style="{
                visibility: showbuttonsavesig1 ? 'visible' : 'hidden',
              }">
                <v-col align="center">
                  <v-btn depressed class="ml-5" @click="clearsig1()">
                    Clear
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn class="mr-5 mb-5 primary" depressed @click="savesig1()">
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
            <v-btn disabled class="mr-2 mb-5" @click="editsig1()">
              {{ defaultwordbuttonsig1 }}
              <v-icon right>mdi-border-color</v-icon>
            </v-btn>
            <br />
            <hr />
            <p class="text-center">Requester</p>
            <p class="text-center" v-if="lbl_date_request">
              Date {{ daterequester }}
            </p>
          </v-col>
          <v-col align="center" cols="12" md="4">
            <v-row v-if="dialogSignature" :style="{ visibility: showsig1 ? 'visible' : 'hidden' }">
              <VueSignaturePad class="signature" width="90%" height="200" ref="secondsignaturePad" :options="options" />
              <v-row :style="{
                visibility: showbuttonsavesig1 ? 'visible' : 'hidden',
              }">
                <v-col align="center">
                  <v-btn depressed class="ml-5" @click="clearsig1()">
                    Clear
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn class="mr-5 mb-5 primary" depressed @click="savesig1()">
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
            <v-btn disabled class="mr-2 mb-5" @click="editsig1()">
              {{ defaultwordbuttonsig1 }}
              <v-icon right>mdi-border-color</v-icon>
            </v-btn>
            <br />
            <hr />
            <p class="text-center">Approver</p>
            <p class="text-center" v-if="lbl_date_request">
              Date {{ dateapprover }}
            </p>
          </v-col>
          <v-col align="center" cols="12" md="4">
            <v-row v-if="dialogSignature" :style="{ visibility: showsig3 ? 'visible' : 'hidden' }">
              <VueSignaturePad class="signature" width="90%" height="200" ref="thirdsignaturePad" :options="options" />
              <v-row :style="{
                visibility: showbuttonsavesig3 ? 'visible' : 'hidden',
              }">
                <v-col align="center">
                  <v-btn depressed class="ml-5" @click="clearsig3()">
                    Clear
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn class="mr-5 mb-5 primary" depressed @click="savesig3()">
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
            <v-btn disabled class="mr-2 mb-5" @click="editsig3()">
              {{ defaultwordbuttonsig1 }}
              <v-icon right>mdi-border-color</v-icon>
            </v-btn>
            <br />
            <hr />
            <p class="text-center">Accountant</p>
            <p class="text-center" v-if="lbl_date_request">
              Date {{ dateaccountant }}
            </p>
          </v-col>
        </v-row>

        <br />
        <hr />
        <br />
        <div :style="{ display: showbtnadd ? 'show' : 'none' }">
          <v-row>
            <v-col align="center" cols="12" md="12">
              <v-btn depressed class="mr-5 buttonblue" @click="saveClearRequest()">
                Clear Advance
              </v-btn>

              <!-- <v-btn  depressed to="/clearadvance-list">
                Cancel Request
              </v-btn> -->
            </v-col>
            <v-col align="center" cols="12" md="2"> </v-col>
          </v-row>
        </div>
      </v-card>

      <v-dialog v-model="dialogSaveDraft" max-width="30%">
        <v-card>
          <v-card-title primary-title class="justify-center">
            {{ this.messageSaveDraft }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="blue darken-1" text @click="closeSaveDraft"
                          >Cancel</v-btn
                        > -->
            <v-btn color="blue darken-1" text @click="closeSaveDraft">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogpreviewattachfile" max-width="700px">
        <v-card>
          <v-card-title class="text-h5">
            <v-btn icon @click="closepreviewattachfile">
              <v-icon large>mdi-close</v-icon>
            </v-btn>
            Preview PDF File</v-card-title>

          <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
          <div v-if="checkattachfileapreview" v-for="(item, index) in previewpopupattachfile2" :key="index">
            <pdf :src="item" v-for="i in numPagespreviewattach" :key="i" :id="i" :page="i">
              <template slot="loading"> loading content here... </template>
            </pdf>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closepreviewattachfile">Cancel</v-btn>

            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogpreviewattachimage" max-width="700px">
        <v-card>
          <v-card-title class="text-h5">
            <v-btn icon @click="closepreviewattachimage">
              <v-icon large>mdi-close</v-icon>
            </v-btn>
            Preview Image</v-card-title>

          <v-img disabled :src="previewattachimage" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
          </v-img>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closepreviewattachimage">Cancel</v-btn>

            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogconfirmdeleteattachfile" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closedialogconfirmdeleteattachfile">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deletedialogconfirmdeleteattachfile">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
      <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    </v-container>
  </v-card-title>
</template>

<script>
import api from "@/services/api";
import {
  server,
  fileClearAdvance,
  imageClearAdvance,
} from "../services/constants";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
import { imageUrl } from "@/services/constants";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import unity from "@/unity/unity";
import pdfvuer from "pdfvuer";

export default {
  name: "edit-advance",
  data() {
    return {
      link: "",
      preview: null,
      image: null,
      preview_list: [],
      oldpreview_list: [],
      image_list: [],
      sumamount: 0.0,
      sumclearamount: 0.0,
      showbtnadd: true,
      showbtnapprove: false,
      advance_code: [],
      advance_code_list: [],
      advance_code_id: 0,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      customer: [],
      customer_list: [],
      customer_id: 0,
      options: {
        penColor: "#000000",
        backgroundColor: "rgb(255,255,255)",
      },
      initial_data2: "",
      initial_data: "",
      pickbank: false,
      pickcheque: false,
      checkcheque: false,
      checkchequefilled: false,
      showsig1: false,
      showsig2: false,
      showsig3: false,
      showbuttonsavesig1: false,
      showbuttonsavesig2: false,
      defaultwordbuttonsig1: "Signature",
      defaultwordbuttonsig2: "Signature",
      totalleftoveramount: 0.0,
      sumwithdrawamount: 0.0,
      sunamountcleared: 0.0,
      showallamount: "",
      indeximage: null,
      desserts: [
        {
          no: "1",
          detail: "",
          withdrawamount: 0,
        },
      ],
      selectbankname: "",
      bankname: [
        "ธนาคารกรุงเทพ",
        "ธนาคารกสิกรไทย",
        "ธนาคารกรุงไทย",
        "ธนาคารทหารไทยธนชาต",
        "ธนาคารไทยพาณิชย์",
        "ธนาคารกรุงศรีอยุธยา",
        "ธนาคารเกียรตินาคินภัทร",
        "ธนาคารซีไอเอ็มบีไทย",
        "ธนาคารทิสโก้",
        "ธนาคารยูโอบี",
        "ธนาคารไทยเครดิตเพื่อรายย่อย",
        "ธนาคารแลนด์ แอนด์ เฮ้าส์",
        "ธนาคารไอซีบีซี (ไทย)",
        "ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย",
        "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
        "ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย",
        "ธนาคารออมสิน",
        "ธนาคารอาคารสงเคราะห์",
        "ธนาคารอิสลามแห่งประเทศไทย",
      ],
      radioType: ["cash", "cheque"],
      radioGroup: "",
      setusername: localStorage.getItem(server.USERNAME),
      role: localStorage.getItem(server.ROLE),
      department: "DCM",
      daterequester: "",
      dateapprover: "",
      dateaccountant: "",
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      search: "",
      selectedProductId: "",
      confirmDeleteDlg: false,
      mDataArray: [],
      // mDataArray: [{ id: "1", detail: "gg", amout: "1000" }],
      fullPage: true,
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: "Code",
          value: "advance_title",
          class: "bg-colorth tabletextwhite",
          width: "15%",
          sortable: false,
        },
        {
          text: "Description",
          value: "description",
          class: "bg-colorth tabletextwhite",
          width: "35%",
          sortable: false,
        },
        {
          text: "Amount",
          value: "amount",
          class: "bg-colorth tabletextwhite",
          width: "20%",
          sortable: false,
        },
        {
          text: "Expend",
          value: "clear_amount",
          class: "bg-colorth tabletextwhite  text-center",
          width: "15%",
          sortable: false,
        },
        {
          text: "Balance",
          value: "difference_amount",
          class: "bg-colorth tabletextwhite  text-center",
          width: "15%",
          sortable: false,
        },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        code: "",
        description: "",
        amount: 0,
      },
      defaultItem: {
        code: "",
        description: "",
        amount: 0,
      },
      advance_d: {
        // advance_hid: "",
        // advance_title: "",
        // description: "",
        // amount: 0,
        clear_amount: 0,
      },
      requester_detail: {
        signature: "",
      },
      approver_detail: {
        signature: "",
      },
      approver_account: {
        signature: "",
      },
      advance_h: {
        // id: "",
        advance_id: "",
        image: [],
        // customer_id: 0,
        // employee_id: 0,
        // department_id: 0,
        // advance_date: null,
        sum_amount: 0,
        // clear_date: null,
        // payment_type: null,
        // bank_name: null,
        // bank_number: null,
        // cheque_number: null,
        status: null,
        remark: null,
        // create_by: null,
        // create_date: null,
      },
      advance_log: {
        module: "AD",
        module_id: 0,
        approve_id: 0,
        approve_status: 0,
        approve_date: null,
      },
      lbl_date_request: false,
      dialogSignature: false,
      dialogSaveDraft: false,
      messageSaveDraft: "",
      paymentType: "",
      bankName: "",
      bankNumber: "",
      chequeNumber: "",
      remark: "",
      approver_remark: "",
      accountant_remark: "",
      main_id: "",
      customer_name: "",
      advance_d_id: 0,
      advance_h_id: 0,
      advance_date_show: "",
      jobtitle_list: [],
      emp_list: [],
      emp_draw: 0,
      emp_draw_jobtitle: 0,
      showbuttonsavesig3: false,
      filenameattach: [],
      previewpopupattachfile2: [],
      previewpopupattachfile: [],
      checkattachfileapreview: false,
      dialogpreviewattachfile: false,
      dialogpreviewattachimage: false,
      dialogconfirmdeleteattachfile: false,
      numPagespreviewattach: 0,
      previewattachimage: "",
      indexdeleteattachfile: -1,
      getpreview_listattach: [],
      preview_listattach: [],
      image_listattach: [],
    };
  },
  components: {
    pdf: pdfvuer,
    StockCard,
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {
    version() {
      return this.initial_data;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    computedExpectedClearDateFormatted() {
      return unity.formatDate(this.date);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    computedExpectedClearDateFormatted() {
      return unity.formatDate(this.date);
    },
  },

  async mounted() {
    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }

    this.$forceUpdate();
    this.initialize();
    this.loadCustomer();
    this.loadAdvanceCode();
    this.loadEmp();
    this.loadJobtitle();

    const res_acc = await api.getAccountDetail(
      localStorage.getItem(server.USER_ID)
    );
    this.initial_accountant = res_acc.data[0].signature;

    const detailadvanceid = await api.billing_expense_getDetailiIdAdvance(
      this.$route.params.id
    );
    let getemployee_id = detailadvanceid.data[0].employee_id;
    let getapprove_sucess_id = detailadvanceid.data[0].approve_sucess_id;
    let getapprove_account_id = detailadvanceid.data[0].approve_account_id;
    let departmentname = "";

    this.dateapprover = unity.formatDate(
      detailadvanceid.data[0].approve_sucess_date
    );

    this.dateaccountant = unity.formatDate(
      detailadvanceid.data[0].approve_account_date
    );
    if (getemployee_id !== 0) {
      let requester_detail = await api.getAccountDetail(getemployee_id);
      this.requester_detail.signature = requester_detail.data[0].signature;
      departmentname = requester_detail.data[0].department_i_d;
      this.setusername =
        requester_detail.data[0].prename_e_n +
        " " +
        requester_detail.data[0].firstname_e_n +
        " " +
        requester_detail.data[0].lastname_e_n;
      this.initial_requester = this.requester_detail.signature;
      this.oldinitial_requester = this.initial_requester;
    }
    if (getapprove_sucess_id !== 0) {
      let approver_detail = await api.getAccountDetail(getapprove_sucess_id);
      this.approver_detail.signature = approver_detail.data[0].signature;
      this.initial_approver = this.approver_detail.signature;
    }
    if (getapprove_account_id !== 0) {
      let approver_account = await api.getAccountDetail(getapprove_account_id);
      this.approver_account.signature = approver_account.data[0].signature;
      this.initial_accountant = this.approver_account.signature;
    }

    const res_department = await api.billing_expense_getDepartmentByID(departmentname);
    if (res_department.data[0].name) {
      this.department = res_department.data[0].name;
    }

    this.showsig1 = true;
    this.showsig2 = true;
    this.showsig3 = true;
    this.dialogSignature = true;
    this.showdefaultsignature();
    // this.savesig1();
    this.$hideLoader();
  },
  methods: {
    openPreviewMaps(data) {
      // ใช้ Regular Expression เพื่อดึงพิกัดเริ่มต้นและปลายทาง
      const regex = /\(([^)]+)\)/g;
      const matches = [...data.matchAll(regex)];

      if (matches.length >= 2) {
        const origin = matches[0][1]; // พิกัดจุดเริ่มต้น (origin)
        const destination = matches[1][1]; // พิกัดจุดปลายทาง (destination)

        const url = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(
          origin
        )}&destination=${encodeURIComponent(destination)}`;
        window.open(url, "_blank");
      } else {
        console.error("ไม่พบพิกัดจุดเริ่มต้นและปลายทางในข้อมูล");
      }
    },
    async previewattachfile(index) {
      if (this.image_listattach[index].type) {
        this.previewattachimage = this.getpreview_listattach[index];
        this.dialogpreviewattachimage = true;
      } else {
        this.previewattachimage = this.getpreview_listattach[index];
        this.dialogpreviewattachimage = true;
      }
      // if (this.filenameattach[index].split(/[\s.]+/).pop() == "pdf") {
      //   this.previewpopupattachfile2 = [];
      //   await this.getPforpreviewattach(this.getpreview_listattach[index]);
      //   this.previewpopupattachfile2 = this.previewpopupattachfile;
      //   console.log(this.previewpopupattachfile2);
      //   this.checkattachfileapreview = true;
      //   this.dialogpreviewattachfile = true;
      // } else {
      //   this.previewattachimage = this.getpreview_listattach[index];
      //   this.dialogpreviewattachimage = true;
      // }
    },
    async getPforpreviewattach(datafile) {
      this.previewpopupattachfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupattachfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupattachfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreviewattach = pdf.numPages;
        });
      });
      console.log(this.previewpopupattachfile);
    },
    async closepreviewattachfile() {
      this.dialogpreviewattachfile = false;
    },
    async closepreviewattachimage() {
      this.dialogpreviewattachimage = false;
    },
    async confirmdeleteattachfile(index) {
      this.indexdeleteattachfile = index;
      this.dialogconfirmdeleteattachfile = true;
    },
    async closedialogconfirmdeleteattachfile() {
      this.indexdeleteattachfile = -1;
      this.dialogconfirmdeleteattachfile = false;
    },
    async deletedialogconfirmdeleteattachfile() {
      this.filenameattach.splice(this.indexdeleteattachfile, 1);
      this.preview_listattach.splice(this.indexdeleteattachfile, 1);
      this.image_listattach.splice(this.indexdeleteattachfile, 1);
      this.getpreview_listattach.splice(this.indexdeleteattachfile, 1);
      this.dialogconfirmdeleteattachfile = false;
    },
    async loadEmp() {
      const result = await api.getAccountslist_by_ComID(
        localStorage.getItem(server.COMPANYID)
      );

      this.emp_list = result.data;
    },
    async loadJobtitle() {
      const result = await api.getAllJobtitleByCompany(
        localStorage.getItem(server.COMPANYID)
      );

      this.jobtitle_list = result.data;
    },
    async removeimage(index) {
      this.preview_list.splice(this.indeximage, 1);
      this.image_list.splice(this.indeximage, 1);

      this.dialogDelete = false;
    },
    async loadAdvanceCode() {
      // console.log("loadAdvanceCode");

      let company_id = localStorage.getItem(server.COMPANYID);

      // console.log("loadAdvanceCode company_id:" + company_id);

      const result = await api.billing_expense_getAllAdvanceCodeByCompany(
        company_id
      );

      // console.log("loadAdvanceCode : ", JSON.stringify(result.data));
      this.advance_code = result.data;

      result.data.forEach((item) => {
        this.advance_code_list.push(item.code + " " + item.description);
      });
    },
    onSelectAdvanceCodeChange(acvance_code) {
      // var tmp = null;
      // tmp = this.customer.filter((c) => c.name.includes(search_customer));

      // this.customer_id = tmp[0].id;
      // console.log("acvance_code : " + acvance_code);
      var tmp = acvance_code.split(" ");
      this.editedItem.advance_title = tmp[0];
      this.editedItem.description = tmp[1];
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async saveClearRequest() {
      if (this.paymentType == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "Please complete all of the required fields.",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.paymentType == "transfer") {
        // alert("กรุณาเลือกลูกค้า");
        if (this.selectbankname == "" || this.bankNumber == null) {
          // this.messageSaveDraft = "กรุณากรอกข้อมูลธนาคารให้ถูกต้อง";
          // this.dialogSaveDraft = true;
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "Please complete all of the required fields.",
            "text-h5 red--text text-center"
          );
          this.$refs["Select Bank"].focus();
          return;
        }
        this.chequeNumber = "";
      } else if (this.paymentType == "cheque") {
        // alert("กรุณาเลือกลูกค้า");
        if (this.chequeNumber == "") {
          // this.messageSaveDraft = "กรุณากรอกเลขที่เช็คให้ถูกต้อง";
          // this.dialogSaveDraft = true;
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "Please complete all of the required fields.",
            "text-h5 red--text text-center"
          );
          this.$refs["Cheque No"].focus();
          return;
        }
        this.selectbankname = "";
        this.bankNumber = "";
      } else if (this.paymentType == "cash") {
        this.chequeNumber = "";
        this.selectbankname = "";
        this.bankNumber = "";
      }

      this.$showLoader();

      let formData = new FormData();

      formData.append("sum_amount", this.sumamount);
      formData.append("sum_clear_amount", this.sumclearamount);
      formData.append("sum_difference_amount", this.sumwithdrawamount);


      formData.append("status", 8);
      formData.append("clear_payment_type", this.paymentType);
      formData.append("clear_bank_name", this.selectbankname);
      formData.append("clear_bank_number", this.bankNumber);
      formData.append("clear_cheque_number", this.chequeNumber);


      // ---------- ไฟล์แนบ (หลายไฟล์) ----------
      if (this.image_listattach && this.image_listattach.length > 0) {
        this.image_listattach.forEach((file) => {
          formData.append("file", file);

        });
      }
      try {
        // ----------เรียก API ----------
        const res_h = await api.billing_expense_updateclearAdvanceH(
          this.advance_h_id,
          formData
        );

        if (res_h.status == 200 || res_h.status == 201) {
          if (this.desserts.length > 0) {
            this.desserts.forEach((item) => {
              this.advance_d_id = item.id;
              this.advance_d.clear_amount = item.clear_amount;
              api.billing_expense_updateAdvanceD(this.advance_d_id, this.advance_d);
            });

            this.advance_log.module_id = this.advance_h_id;
            this.advance_log.approve_id = localStorage.getItem(server.USER_ID);
            this.advance_log.approve_status = 8;
            this.advance_log.approve_date = new Date();

            const res_log = await api.billing_expense_addAdvanceLog(this.advance_log);
            if (res_log.status == 200 || res_log.status == 201) {
              this.$hideLoader();
              this.$store.state.global_push_dialog = true;
              this.setupAlertDialogPush(
                true,
                "Information Saved",
                "Request successfully saved and sent to accountant.",
                "text-h5 green--text text-center",
                "/clearadvance-list"
              );
            } else {
              this.$hideLoader();
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Information Saved",
                "Please complete all of the required fields.",
                "text-h5 red--text text-center"
              );
            }
          }
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "Please complete all of the required fields.",
            "text-h5 red--text text-center"
          );
        }
      } catch (error) {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "Please complete all of the required fields.",
          "text-h5 red--text text-center"
        );
      }
      // this.$router.push("/clearadvance-list").catch((err) => {});
    },

    changeFocusText(t) {
      // alert(t);
      if (t === 1) {
        this.$refs["txtCode"].focus();
      } else if (t === 2) {
        this.$refs["txtDescription"].focus();
      } else if (t === 3) {
        if (this.editedItem.advance_title == "") {
          alert("กรุณากรอกรหัสการขออนุมัติ");
          this.$refs["txtCode"].focus();
        } else {
          this.$refs["txtAmount"].focus();
        }
      }
    },
    initialize() {
      // this.sumwithdrawamount = 0;
      // this.desserts.forEach((item) => {
      //   this.sumwithdrawamount += item.amount;
      // });
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },

    deleteItemConfirm(index) {
      this.indeximage = index;
      this.dialogDelete = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeSaveDraft() {
      this.dialogSaveDraft = false;
    },

    closeDelete() {
      this.indeximage = null;
      // this.sumwithdrawamount = 0;

      // this.desserts.forEach((item) => {
      //   this.sumwithdrawamount += parseInt(item.amount, 10);
      // });

      this.dialogDelete = false;
      // this.$nextTick(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem);
      //   this.editedIndex = -1;
      // });
    },

    save() {
      if (this.editedItem.advance_title == "") {
        alert("กรุณากรอกรหัสการขออนุมัติ");
        this.$refs["txtCode"].focus();
        return;
      }

      if (this.editedItem.amount == "0" || this.editedItem.amount == 0) {
        alert("กรุณากรอกจำนวนเงิน");
        this.$refs["txtAmount"].focus();
        return;
      }

      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }

      // this.sumwithdrawamount = 0;

      // this.desserts.forEach((item) => {
      //   this.sumwithdrawamount += parseInt(item.amount, 10);
      // });
      console.log("save : " + JSON.stringify(this.desserts));
      this.changeFocusText(1);
      this.close();
    },
    onSelectCustomerChange(search_customer) {
      var tmp = null;
      tmp = this.customer.filter((c) => c.name.includes(search_customer));

      this.customer_id = tmp[0].id;
      // console.log("customer : " + this.customer_id);
    },

    async loadCustomer() {
      // console.log("loadCustomer");
      const result = await api.getAllCustomerList();
      // console.log("result.data : ", JSON.stringify(result.data));
      this.customer = result.data;

      result.data.forEach((item) => {
        this.customer_list.push(item.name);
      });

      //   console.log("this customer:" + JSON.stringify(this.customer));

      //   console.log("this customer:" + this.advance_h.customer_id);
      //   var tmp = null;
      //   tmp = this.customer.filter((c) =>
      //     c.id.includes(1)
      //   );

      let cs_id = parseInt(this.advance_h.customer_id, 10);

      let fill_cus = this.customer.filter(function (c) {
        return c.id == cs_id;
      });
      //   console.log("this customer:" + fill_cus);
      //   console.log("this customer:" + JSON.stringify(fill_cus));
      this.customer_name = fill_cus[0].name;
    },

    editsig1() {
      this.dialogSignature = true;
      this.lbl_date_request = false;
      this.showsig1 = true;
      this.showbuttonsavesig1 = true;
      this.$refs.firstsignaturePad.openSignaturePad();
    },
    editsig2() {
      this.showsig2 = true;
      this.showbuttonsavesig2 = true;
      this.$refs.secondsignaturePad.openSignaturePad();
    },
    editsig3() {
      this.showsig3 = true;
      this.showbuttonsavesig3 = true;
      this.$refs.thirdsignaturePad.openSignaturePad();
    },
    clearsig1() {
      this.lbl_date_request = false;
      this.$refs.firstsignaturePad.clearSignature();
    },
    clearsig2() {
      this.$refs.secondsignaturePad.clearSignature();
    },
    clearsig3() {
      this.$refs.thirdsignaturePad.clearSignature();
    },
    savesig1() {
      this.lbl_date_request = true;
      this.defaultwordbuttonsig1 = "Edit";
      const { isEmpty, data } = this.$refs.firstsignaturePad.saveSignature();
      this.showbuttonsavesig1 = false;
      this.$refs.firstsignaturePad.lockSignaturePad();
      // console.log("initial_requester : " + data);
      // console.log("initial_requester1 : " + this.initial_requester);
      this.initial_requester = data;
    },
    savesig2() {
      this.defaultwordbuttonsig2 = "Edit";
      const { isEmpty, data } = this.$refs.secondsignaturePad.saveSignature();
      this.showbuttonsavesig2 = false;
      this.$refs.secondsignaturePad.lockSignaturePad();
    },
    savesig3() {
      this.defaultwordbuttonsig3 = "Edit";
      const { isEmpty, data } = this.$refs.thirdsignaturePad.saveSignature();
      this.showbuttonsavesig3 = false;
      this.$refs.thirdsignaturePad.lockSignaturePad();
      this.initial_accountant = data;
    },
    changeradio() {
      console.log(this.radioGroup);
      if (this.radioGroup === "cheque") {
        this.paymentType = "cheque";
        this.pickbank = false;
        this.pickcheque = true;
      } else if (this.radioGroup === "bank") {
        this.paymentType = "transfer";
        this.pickcheque = false;
        this.pickbank = true;
      } else {
        this.paymentType = "cash";
        this.pickcheque = false;
        this.pickbank = false;
      }
    },

    showdefaultsignature() {
      this.$nextTick(() => {
        // this.$refs.signaturePaddefault.fromDataURL(this.initial_data);
        // this.$refs.signaturePaddefault.lockSignaturePad();
        this.$refs.firstsignaturePad.fromDataURL(this.initial_requester);
        // this.requester_detail.signature
        this.$refs.firstsignaturePad.lockSignaturePad();
        this.$refs.secondsignaturePad.fromDataURL(this.initial_approver);
        this.$refs.secondsignaturePad.lockSignaturePad();
        this.$refs.thirdsignaturePad.fromDataURL(this.initial_accountant);
        this.$refs.thirdsignaturePad.lockSignaturePad();
      });
    },
    Caltotleamount(item) {
      this.sumamount = 0;
      this.sumclearamount = 0;
      this.sumwithdrawamount = 0;
      this.desserts.forEach((x, index) => {
        x.difference_amount = parseFloat(x.amount - x.clear_amount);
        this.sumamount += parseFloat(x.amount);
        // if (x.clear_amount == "" || x.clear_amount == NaN) {
        //   x.clear_amount = 0;
        // }
        this.sumclearamount += parseFloat(x.clear_amount);
      });
      this.sumwithdrawamount = parseFloat(this.sumamount - this.sumclearamount);
    },
    restrictDecimal(item) {
      return item.match(/^\d+\.?\d{0,2}/);
    },
    previewImage: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewMultiImage: function (event) {
      this.filenameattach = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            // this.preview_list.push(e.target.result);
            this.getpreview_listattach.push(e.target.result);
            this.preview_listattach.push(e.target.result);
          };
          if (
            input.files[index].type === "application/pdf" ||
            input.files[index].type.split("/")[0] === "image"
          ) {
            this.image_listattach.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      console.log(this.image_listattach);
      this.image_listattach.forEach((x) => {
        if (x.name) {
          this.filenameattach.push(x.name);
        } else {
          this.filenameattach.push(x.split(/[\s/]+/).pop());
        }
      });
    },
    reset: function () {
      this.image = null;
      this.preview = null;
      this.image_list = [];
      this.preview_list = [];
      this.oldpreview_list = [];
    },
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;

    this.main_id = this.$route.params.id;

    const res_h = await api.billing_expense_getAllHById(this.main_id);

    if (res_h.data[0].image) {
      let dataso_h = res_h.data[0];
      this.filenameattach = dataso_h.image.split(",");
      this.filenameattach.forEach((x, index) => {
        if (x.split(/[\s.]+/).pop() == "pdf") {
          this.image_listattach.push(
            `${fileClearAdvance}/${this.$route.params.id}/${x}`
          );
          this.getpreview_listattach.push(
            `${fileClearAdvance}/${this.$route.params.id}/${x}`
          );
        } else {
          this.image_listattach.push(
            `${imageClearAdvance}/${this.$route.params.id}/${x}`
          );
          this.getpreview_listattach.push(
            `${imageClearAdvance}/${this.$route.params.id}/${x}`
          );
        }
      });
    }
    this.advance_h_id = res_h.data[0].id;
    this.advance_h.advance_id = res_h.data[0].advance_id;
    this.advance_h.customer_id = res_h.data[0].customer_id;
    this.emp_draw = res_h.data[0].emp_draw;
    this.emp_draw_jobtitle = res_h.data[0].emp_draw_jobtitle;

    // this.customer_name = tmp[0].name;

    this.advance_h.employee_id = res_h.data[0].employee_id;
    this.advance_h.department_id = res_h.data[0].department_id;
    // this.sumwithdrawamount = res_h.data[0].sum_amount;

    this.daterequester = unity.formatDate(res_h.data[0].advance_date);

    //detail franfer from accountant
    this.advance_h.payment_type = res_h.data[0].clear_payment_type;
    this.advance_h.bank_name = res_h.data[0].clear_bank_name;
    this.advance_h.bank_number = res_h.data[0].clear_bank_number;
    this.advance_h.cheque_number = res_h.data[0].clear_cheque_number;

    this.bankNumber = this.advance_h.bank_number;
    this.selectbankname = this.advance_h.bank_name;
    this.chequeNumber = this.advance_h.cheque_number;

    if (this.advance_h.payment_type === "cheque") {
      this.paymentType = "cheque";
      this.pickbank = false;
      this.pickcheque = true;
      this.radioGroup = "cheque";
    } else if (this.advance_h.payment_type === "transfer") {
      this.paymentType = "transfer";
      this.pickcheque = false;
      this.pickbank = true;
      this.radioGroup = "bank";
    } else if (this.advance_h.payment_type === "cash") {
      this.paymentType = "cash";
      this.pickcheque = false;
      this.pickbank = false;
      this.radioGroup = "cash";
    }

    this.advance_h.status = res_h.data[0].status;
    this.remark = res_h.data[0].remark;
    this.approver_remark = res_h.data[0].approver_remark;
    this.accountant_remark = res_h.data[0].accountant_remark;
    this.advance_h.create_by = res_h.data[0].create_by;
    this.advance_h.create_date = res_h.data[0].create_date;

    this.advance_h.advance_date = res_h.data[0].advance_date;
    this.advance_date_show = unity.formatDate(res_h.data[0].advance_date);

    const res_d = await api.billing_expense_getAllDById(this.$route.params.id);
    // console.log("res_d : " + JSON.stringify(res_d.data));
    this.desserts = res_d.data;

    if (this.desserts) {
      this.sumamount = 0;
      this.sumclearamount = 0;
      this.sumwithdrawamount = 0;
      this.desserts.forEach((x, index) => {
        x.difference_amount = parseFloat(x.amount - x.clear_amount);
        this.sumamount += parseFloat(x.amount);
        this.sumclearamount += parseFloat(x.clear_amount);
      });
      this.sumwithdrawamount = parseFloat(this.sumamount - this.sumclearamount);
    }

  },
  async created() {
    // this.showdefaultsignature();
  },
};
</script>

<style scoped>
.description-text {
  cursor: pointer !important;
  transition: color 0.3s ease !important;
}

.description-text:hover {
  color: darkblue !important;
  /* สีที่เปลี่ยนเมื่อ hover */
}

.bg-colorth {
  background-color: #515151;
  color: red;
}

.text-left {
  color: aliceblue;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.v-autocomplete.v-input>.v-input__control>.v-input__slot {
  min-height: 10px;
}

.widthsizeformadvance {
  width: 60%;
}

.bd-block-tb {
  border-block: 1px solid gray;
  writing-mode: horizontal-tb;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.bd-block-lr {
  border-block: 1px solid gray;
  writing-mode: vertical-lr;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.widthsize80formadvance {
  width: 80%;
}

.heightsize55formadvance {
  height: 55px;
}

.heightsize80performadvance {
  height: 60%;
}

.heightsize70formadvance {
  height: 70px;
}

.widthsize8055formadvance {
  width: 80px;
  height: 55px;
}

.advance-text-height {
  height: 70px;
}

.some-other-style {
  background: blue;
}

.data-table-button {
  color: #9e3b1b;
}

.inputsize {
  font-size: smaller;
}

.btnuploadfile {
  border: 2px solid;
}
</style>
